function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 16,
  fill: "#12908D",
  stroke: "white",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.3045 17.1992L17.2377 11.9645C16.7428 11.6788 16.1962 11.646 15.78 11.8771C15.78 11.8771 10.482 13.8698 10.1388 14.4643C9.7956 15.0587 10.7188 20.6433 10.7188 20.6433C10.7268 21.1193 11.0285 21.5763 11.5234 21.862L20.5902 27.0967C21.3678 27.5457 22.3714 27.2767 22.8204 26.4991L26.902 19.4295C27.351 18.6518 27.0821 17.6482 26.3045 17.1992ZM12.879 17.8609C13.5965 18.2751 14.5139 18.0293 14.9281 17.3119C15.3423 16.5944 15.0965 15.677 14.379 15.2628C13.6616 14.8486 12.7442 15.0944 12.33 15.8119C11.9158 16.5293 12.1616 17.4467 12.879 17.8609Z",
  fill: "#4A5862"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.3045 14.1992L16.2377 8.96454C15.7428 8.67883 15.1962 8.64602 14.78 8.87705C14.78 8.87705 9.482 10.8698 9.1388 11.4643C8.7956 12.0587 9.71881 17.6433 9.71881 17.6433C9.72681 18.1193 10.0285 18.5763 10.5234 18.862L19.5902 24.0967C20.3678 24.5457 21.3714 24.2767 21.8204 23.4991L25.902 16.4295C26.351 15.6518 26.0821 14.6482 25.3045 14.1992ZM11.879 14.8609C12.5965 15.2751 13.5139 15.0293 13.9281 14.3119C14.3423 13.5944 14.0965 12.677 13.379 12.2628C12.6616 11.8486 11.7442 12.0944 11.33 12.8119C10.9158 13.5293 11.1616 14.4467 11.879 14.8609Z",
  fill: "white"
});

function SvgIconLogbookUserDefined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogbookUserDefined);
export default __webpack_public_path__ + "static/media/iconLogbookUserDefined.9858aa6c.svg";
export { ForwardRef as ReactComponent };